document.addEventListener('DOMContentLoaded', (event) => {
  
  
    const drawerLinks = Array.from(document.querySelectorAll('a.menu-drawer__menu-item'));
    drawerLinks.map((link) => {
        link.addEventListener('click', function(e) {
            const href = this.getAttribute('href').substring(1);
            const current = window.location.pathname;
            if( href.includes('#') && current == '/' ) {
            e.preventDefault();
           
            document.querySelector(`${href}`).scrollIntoView({ block: "center", behavior: "smooth" });
            }
           
        })
    });
    
    const menuLinks = Array.from(document.querySelectorAll('a.header__menu-item'));
    menuLinks.map((link) => {
        link.addEventListener('click', function(e) {
            const href = this.getAttribute('href').substring(1);
            const current = window.location.pathname;
            if( href.includes('#') && current == '/' ) {
            e.preventDefault();
                
            document.querySelector(`${href}`).scrollIntoView({ block: "center", behavior: "smooth" });
            }
           
        })
    });
  
//   const reviewLinks = Array.from(document.querySelectorAll('a.review-link'));
//     reviewLinks.map((link) => {
//         link.addEventListener('click', function(e) {
//             const href = this.getAttribute('href').substring(1);
//             const current = window.location.pathname;
//             if( href.includes('#') && current == '/' ) {
//             e.preventDefault();
                
//             document.querySelector(`${href}`).scrollIntoView({ block: "center", behavior: "smooth" });
//             }
           
//         })
//     });
})
